<template>
  <transition name="modal" appear>
    <div class="modal small modal-overlay" @click.self="close">
      <div class="modal-window" :class="modalClass">
        <header class="modal-header">
          <div class="tit" v-html="modalTitle"></div>
          <button @click="close" class="btn_close">닫기</button>
        </header>
        <div class="modal-content" v-html="modalContent">
        </div>
        <footer class="modal-footer" v-if="btnList && btnList.length > 0">
          <template v-for="(btn, inx) in btnList">
            <button
              :key="'btn' + inx"
              :class="btn.class"
              type="button"
              @click="btn.click(self, $event)">
              {{btn.label}}
            </button>
          </template>
        </footer>
      </div>
    </div>
  </transition>
</template>
<script>
export default {
  data() {
    return {
      self: this,
      modalTitle: this.$i18nUtil.trans("title.dialog.notice","알림"),
      modalContent: "",
      modalClass: "alert",
      btnList: [
        { label: this.$i18nUtil.trans("button.dialog.confirm","확인"), class: "btn_ty1", click: this.close, }
      ]
    };
  },
  mounted() {
    let info = this.$attrs.modalInfo;
    for (let k in info) {
      if (info[k]) {
        this[k] = info[k];
      }
    }
  },
  methods: {
    close(self, e) {
      this.$emit("close");
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/cowork/general/board/modal/SimpleModal.vue